import { AuthenticatedPatientPortal } from "route-components/AuthenticatedPatientPortal";
import { createFileRoute } from "@tanstack/react-router";

/** Route for authenticated Patient Portal functionality. */
export const Route = createFileRoute("/$token/$channel")({
    component: AuthenticatedPatientPortal,
});
